module.exports = file => () => import('@/views/' + file + '/index.vue')



// WEBPACK FOOTER //
// ./src/router/_import_test.js